import { render } from "./Popup.vue?vue&type=template&id=4287087a"
import script from "./Popup.vue?vue&type=script&lang=js"
export * from "./Popup.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Trix\\Documents\\manga-corporation-V2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__